import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import img1 from '../../assets/images/claudio-schwarz-9THCtPV2Nkg-unsplash.jpg';
import img2 from '../../assets/images/arno-senoner-PXZXr7EASLc-unsplash.jpg';
import img3 from '../../assets/images/nais-6gKtMb7elS8-unsplash.jpg';
import img4 from '../../assets/images/simon-kadula-8gr6bObQLOI-unsplash.jpg';


const products = [
  {
    title: 'CED Coating Plants',
    image: img1,
  },
  {
    title: 'Pre-treatment & Material Handling Systems',
    image: img2,
  },
  {
    title: 'Plant Equipment & Structures',
    image: img3,
  },
  {
    title: 'CED Coating Line Components',
    image: img4,
  },
];

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: 'easeOut',
    },
  }),
};

const ProductsSection = () => {
  const navigate = useNavigate();

  const handleViewMore = () => {
    navigate('/Service');
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <section className="bg-[rgb(241,240,234)] text-[#1b1b1b] py-16 px-4 text-center">
      <motion.p
        className="text-[#7d3f3f] text-sm mb-2 font-semibold"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        Our Industrial Solutions
      </motion.p>

      <motion.h2
        className="text-4xl font-bold mb-4"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        CED Coating & Surface Treatment Solutions
      </motion.h2>

      <motion.p
        className="max-w-4xl mx-auto text-sm md:text-base text-[#333333] mb-12"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        We offer a wide range of industrial products including high-performance CED Coating Plants, efficient Pre-treatment Systems, durable Plant Equipment, and precision Material Handling solutions designed to meet diverse surface treatment needs.
      </motion.p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
        {products.map((product, idx) => (
          <motion.div
            key={idx}
            className="bg-[#e9f1f7] text-black rounded-md shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col justify-between h-[450px] transform hover:-translate-y-1 hover:scale-[1.02] transition-transform duration-300 ease-in-out"
            custom={idx}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <div className="h-64 overflow-hidden rounded-t-md">
              <img
                src={product.image}
                alt={product.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-4 flex flex-col justify-between flex-grow">
              <h3 className="text-lg font-semibold mb-4">{product.title}</h3>
              <button
                onClick={handleViewMore}
                className="mt-auto bg-[#7d3f3f] text-white px-4 py-2 text-sm rounded hover:bg-[#5e2e2e] transition-colors"
              >
                View More →
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ProductsSection;
